var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18,11H12a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15,14a1,1,0,0,1-1-1V7a1,1,0,0,1,2,0v6A1,1,0,0,1,15,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,3A3,3,0,1,1,3,6,3,3,0,0,1,6,3M6,1a5,5,0,1,0,5,5A5,5,0,0,0,6,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,14a4.652,4.652,0,0,1,3.783,1.445A11.13,11.13,0,0,1,6,16a10.917,10.917,0,0,1-3.818-.542C2.641,14.743,3.959,14,6,14m0-2c-3.75,0-6,2-6,4,0,1,2.25,2,6,2,3.518,0,6-1,6-2C12,14,9.646,12,6,12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.fb0f5d3e0c2c8807667a87500e94a7a2.svg";
export { ForwardRef as ReactComponent };